export const blockIconsNavigationArrowLeft = (
	<span className='material-symbols-outlined'>arrow_left</span>
);
